<template>
  <v-app>
    <v-main class="grey darken-3">
      <v-container
        class="fill-height"
        fluid
      >
        <v-row class="justify-center">
          <v-col cols="auto">
            <slot />
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <app-footer />
  </v-app>
</template>

<script>

import AppFooter from '@/theme/default/components/app/AppFooter'

export default {
  name      : 'DefaultLayout',
  components: { AppFooter },
  mixins    : [],
  data () {
    return {}
  },
  computed: {},
  watch   : {},
  created () {},
  mounted () {},
  updated () {},
  beforeDestroy () {},
  methods : {}
}

</script>

<style scoped>

</style>
